// extracted by mini-css-extract-plugin
export default {"csInner":"InnerCole_csInner__6oPh9"};